import gql from 'graphql-tag';

export const GET_AVAIL_REQ_COMPANIES = gql`
  query availableReqCompanies {
    availableReqCompanies {
      companyID
      companyName
      multCompReqsAllowed
    }
  }
`;

export const REQ_APPROVED_VENDOR_LOOKUP_QUERY = gql`
  query Req_ApprovedVendors($company: String!) {
    approvedVendors(company: $company) {
      VendorNum
      VendorID
      VendorName
      UnitCost
      CurrencyCode
    }
  }
`;

export const REQ_APPROVERS_LOOKUP_QUERY = gql`
  query Req_Approvers($company: String!) {
    approverList(company: $company) {
      value
    }
  }
`;

export const REQ_JOBLIST_LOOKUP_QUERY = gql`
  query Req_JobList($company: String!) {
    jobList(company: $company) {
      ProjectID
      ProjectDesc
      JobNum
      JobDesc
      ProjectManager
    }
  }
`;

export const REQ_DEFAULT_ADDRESS_LOOKUP_QUERY = gql`
  query Req_DefAddr($company: String!) {
    defAddr(company: $company) {
      Company_Name
      Company_Address1
      Company_Address2
      Company_Address3
      Company_City
      Company_State
      Company_Zip
      Company_Country
      Company_CountryNum
    }
  }
`;

export const REQ_COUNTRY_LOOKUP_QUERY = gql`
  query Req_Country($company: String!) {
    reqCountry(company: $company) {
      Country_CountryNum
      Country_Description
    }
  }
`;

export const REQ_PART_CLASS_LOOKUP_QUERY = gql`
  query Req_PartClass($company: String!) {
    partClass(company: $company) {
      value
      label
    }
  }
`;

export const REQ_PARTLIST_LOOKUP_QUERY = gql`
  query Req_PartList($company: String!) {
    partList(company: $company) {
      PartNum
      PartDesc
      ClassID
      IUM
    }
  }
`;

export const REQ_CURRENCY_CODE_LOOKUP_QUERY = gql`
  query Req_CurrencyCode($company: String!) {
    Req_CurrencyCode(company: $company) {
      Currency_CurrencyCode
    }
  }
`;

export const REQ_ANALYSIS_CODE_LOOKUP_QUERY = gql`
  query AnalysisCodes($company: String!) {
    acAnalysisCodes(company: $company) {
      AnalysisCd_Company
      AnalysisCd_AnalysisCode
      AnalysisCd_Description
      AnalysisCd_InActive
    }
  }
`;

export const REQ_HEAD_LOOKUP_QUERY = gql`
  query Req_Head($company: String!, $requestorID: String!) {
    reqHead(company: $company, requestorID: $requestorID) {
      ReqHead_ReqNum
      ReqHead_RequestorID
      ReqHead_RequestDate
      ReqHead_CreatedOn
      ReqHead_OpenReq
      Calculated_Status
      Calculated_Approver
    }
  }
`;

export const REQ_DETAIL_LOOKUP_QUERY = gql`
  query Req_Detail($company: String!, $ReqNum: Int!) {
    reqDetail(company: $company, ReqNum: $ReqNum) {
      ReqDetail_ReqNum
      ReqDetail_ReqLine
      ReqDetail_OpenLine
      ReqDetail_PartNum
      ReqDetail_LineDesc
      Project_ProjectID
      Project_Description
      JobHead_JobNum
      ReqDetail_OrderQty
      ReqDetail_IUM
      ReqDetail_UnitCost
      ReqDetail_CurrencyCode
      Calculated_ExtCost
      PORel_PONum
      PORel_POLine
      POHeader_OrderDate
    }
  }
`;

export const CREATE_REQUISITION_MUTATION = gql`
  mutation CreateRequisition(
    $company: String!
    $efxLibraryID: String!
    $efxFunctionID: String!
    $params: RequisitionInput!
  ) {
    createRequisition(
      company: $company
      efxLibraryID: $efxLibraryID
      efxFunctionID: $efxFunctionID
      params: $params
    ) {
      output
    }
  }
`;

export const CREATE_REQUISITION_ATTACHMENT_MUTATION = gql`
  mutation CreateRequisitionAttachment(
    $company: String!
    $efxLibraryID: String!
    $efxFunctionID: String!
    $params: RequisitionAttachmentInput!
  ) {
    createRequisitionAttachment(
      company: $company
      efxLibraryID: $efxLibraryID
      efxFunctionID: $efxFunctionID
      params: $params
    ) {
      output
    }
  }
`;
